import { BREADCRUMBS_UPDATE } from 'src/react/components/breadcrumbs/constants';

var breadcrumbsUpdate = function breadcrumbsUpdate(crumb) {
  return {
    type: BREADCRUMBS_UPDATE,
    payload: {
      crumb: crumb
    }
  };
};

export default breadcrumbsUpdate;